import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
type Props = {
  title: string;
  description?: string;
  back?: {
    to: string;
    label: string;
  };
  actions?: ReactNode;
};

/** Titel, uitleg, terug-link en acties bovenaan elke beheerpagina. */
export function PageHeader({
  title,
  description,
  back,
  actions
}: Props) {
  return <div className="mb-6 sm:mb-8" data-id="element-5097" data-mp="378laj72080u9">
      {back && <Link to={back.to}
    // Telefoon: een volwaardig tikvlak (44px), want dit is de weg terug naar de lijst.
    className="-ml-2 mb-2 inline-flex min-h-[44px] items-center gap-1.5 rounded-md px-2 text-[14px] text-muted transition-colors duration-150 ease-soft hover:text-ink sm:mb-3 sm:min-h-0 sm:py-1.5 sm:text-[13px]" data-id="element-5098" data-mp="3781szrg9negr">
          <ArrowLeftIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-5099" data-mp="3pzkuftun6kgo" />
          {back.label}
        </Link>}
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-5100" data-mp="3l7kpfmzpt1d8">
        <div className="max-w-2xl" data-id="element-5101" data-mp="yrnt8iqvoofs">
          <h1 className="font-display text-[1.7rem] font-light leading-tight text-ink sm:text-[2rem]" data-id="element-5102" data-mp="yspdndtsana6">{title}</h1>
          {description && <p className="mt-1.5 text-[14px] leading-relaxed text-muted" data-id="element-5103" data-mp="12vlpmlotjl55">{description}</p>}
        </div>
        {actions && <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto [&>*]:flex-1 sm:[&>*]:flex-none" data-id="element-5104" data-mp="u17caonumkoo">{actions}</div>}
      </div>
    </div>;
}